import { useJobRefetch } from '@hooks/job/refetch';
import { DefaultApiResp } from '@root/globalTypes';
import { queryFetch } from '@services/api';
import { useMutation } from '@tanstack/react-query';
import { useShowErrorToast } from '@utils/formHelpers';

export const useResolveIssue = ({
  id,
  jobId,
  taskId,
}: {
  id: string;
  jobId: string;
  taskId: string;
}) => {
  const { refetch, stages, task } = useJobRefetch();
  const { showErrorToast } = useShowErrorToast();

  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<DefaultApiResp> =>
      queryFetch({
        url: `issues/${id}/resolve`,
        opt: { method: 'PUT' },
      }),
    onMutate: async () =>
      stages.update({
        jobId,
        task: {
          id: taskId,
          issues: task
            .get(jobId, taskId)
            ?.issues?.map((el) => (el.id === id ? { ...el, resolved: true } : el)),
        },
      }),
    onError: (err, _, prev) => {
      console.error(err);
      stages.restore(jobId, prev);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      const { errors } = data as DefaultApiResp;
      if (errors) showErrorToast(errors);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
